module.exports = __webpack_public_path__ + "assets/media/user-member-lovel07.b64a8100.png";